import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=12bccb3b&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=js&"
export * from "./Paginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bccb3b",
  null
  
)

export default component.exports